import common = require("../common");
import AjaxService = require("../services/AjaxService");
import Core = require("../core");
import moment = require('moment');
import utilities = require("../modules/utilities");

interface IPoolerConfig {
    frequencySec?: number;
    poolingUrl: string;
}

interface IPoolableItem {
    item: common.IPoolable;
}

class Pooler {

    private readonly _defaultFrequencySec = 30;
    private readonly _ajaxService: AjaxService;
    private readonly _config: IPoolerConfig;
    private _isRunning = false;
    private _latestTimeout = null as any;
    private _poolingDate = null as Date;
    private _lastPoolingDate = null as Date;
    private _iteration = -1;
    private _registry = [] as IPoolableItem[];

    constructor(config: IPoolerConfig) {
        if (!config)
            throw "L'argument 'config' est requis.";

        if (!config.poolingUrl)
            throw "L'argument 'config.poolingUrl' est requis.";

        this._config = config;

        if (!this._config.frequencySec)
            this._config.frequencySec = this._defaultFrequencySec;

        this._ajaxService = new AjaxService();
    }

    start() {
        if (this._isRunning)
            return this;

        this._isRunning = true;

        this.pool();

        return this;
    }

    stop() {
        if (!this._isRunning)
            return this;

        this._isRunning = false;

        if (this._latestTimeout)
            clearTimeout(this._latestTimeout);

        return this;
    }

    restart() {
        this.stop();
        this.start();
        return this;
    }

    registerPoolable(obj: common.IPoolable) {
        if (!obj)
            throw "L'argument 'inst' est requis, mais est NULL.";

        this._registry.push({
            item: obj,
            lastPoolingDate: null
        } as IPoolableItem);

        return this;
    }

    unregisterPoolable(obj: common.IPoolable) {
        if (!obj)
            throw "L'argument 'inst' est requis, mais est NULL.";

        const index = this._registry.findIndex(x => x.item === obj);
        if (index >= 0)
            this._registry.splice(index, 1);

        return this;
    }

    private toUtcString(date: Date) {
        if (!date)
            return null;

        const m = moment(date);

        m.add(-1 * m.utcOffset(), 'minutes');

        return m.utc().toISOString();
    }

    private getPoolingInformations() {

        return {
            frequencySec: this._config.frequencySec,
            iteration: this._iteration,
            poolingDate: this._poolingDate,
            poolingDateUtcString: this.toUtcString(this._poolingDate),
            lastPoolingDate: this._lastPoolingDate || null,
            lastPoolingDateUtcString: this.toUtcString(this._lastPoolingDate)
        } as common.IPoolerInformations;
    }

    /** Retournera l'objet d'arguments SEULEMENT si la requette doit etre envoyé. */
    private buildPostArguments() {
        var mustSend = false;

        const info = this.getPoolingInformations();

        //const data = new FormData();
        // data.append("iteration", info.iteration.toString());
        // data.append("poolingDate", info.poolingDateUtcString);
        // data.append("lastPoolingDate", info.lastPoolingDateUtcString);
        // data.append("currentUrl", utilities.currentUrl());
        // data.append("messagesManagerFetchArgs", null);
        // data.append("searchBoxFetchArgs", null);

        const data = {
            iteration: info.iteration,
            poolingDate: info.poolingDateUtcString,
            lastPoolingDate: info.lastPoolingDateUtcString,
            currentUrl: utilities.currentUrl(),
            messagesManagerFetchArgs: null,
            searchBoxFetchArgs: []
        } as common.IPoolerFetchArguments;

        this._registry.forEach(x => {
            const go = x.item.onPooling(data, info);
            if (!mustSend && go)
                mustSend = true;
        });

        return mustSend ? data : null;
    }

    private pool() {
        this._iteration++;

        const repool = () => {
            const d = this._config.frequencySec * 1000;
            this._latestTimeout = setTimeout(() => {
                this.pool();
            }, d);
        };

        const postArgs = this.buildPostArguments();

        if (postArgs)
            this._ajaxService.post(this._config.poolingUrl, postArgs, true, (responseData: common.IPoolingFetchResponseData) => {
                const errors = [];

                // Validation de la reponse
                if (!responseData)
                    errors.push(new Core.Error("Les données retournées par le système de mise à jour (ApiPooling) sont NULL."));

                // Application des callbacks
                if (errors.length)
                    this.onPoolingError(errors);
                else
                    this.onPoolingSuccess(responseData);

                // Relancer le pooler
                repool();
            }, (errors, config) => {

                this.onPoolingError(errors, true);

                //NOTE: en cas d'erreur 140 (unauthorized) on stop le pooler.
                if (errors && errors.length > 0 && errors[0].code === 140) {
                    stop();
                }
                else {
                    repool();
                }

            });
        else
            repool();
    }

    private onPoolingSuccess(data: common.IPoolingFetchResponseData) {
        this._registry.forEach(x => {
            if (x.item.onPoolingSuccess)
                x.item.onPoolingSuccess(data);
        });
    }

    private onPoolingError(errors: common.IError[], isHttpError?: boolean) {
        isHttpError = isHttpError === true;

        if (isHttpError) {
            var m = '';
            (errors || []).forEach(x => {
                if (m) m += ' ||| ';
                m += x.message;
                if (x.code)
                    m += " (" + x.code + ").";
            });
            m = '[UpaSti/Pooler] Une ou plusieurs erreurs sont survues : ' + m;
            utilities.printError(m);
            return;
        }

        this._registry.forEach(x => {
            if (x.item.onPoolingError)
                x.item.onPoolingError(errors);
        });
    }
}

export = Pooler;